import { Container, Flex, Skeleton, Text } from "@radix-ui/themes";

const SkeletonList = ({ numberOfItems = 3 }) => {
  const widths = ['w-full', 'w-5/6', 'w-4/5', 'w-3/4', 'w-2/3'];
  
  return (
    <Flex direction="column" gap="2">
      {Array.from({ length: numberOfItems }).map((_, index) => {
        const widthClass = widths[index % widths.length];
        return (
          <Container size="1" key={'skeleton-list-' + index} className={`mb-3 ${widthClass}`}>
            <Flex direction="column" gap="2">
              <Text>
                <Skeleton loading={true} className="w-full" minHeight={"30px"}>Lorem ipsum dolor sit amet.</Skeleton>
              </Text>
          
              <Skeleton loading={true} className="w-3/4" minHeight={"30px"}>
                <Text>Lorem ipsum dolor sit amet</Text>
              </Skeleton>
            </Flex>
          </Container>
        );
      })}
    </Flex>
  );
};

export { SkeletonList };

